// extracted by mini-css-extract-plugin
module.exports = {"button":"TwypI","expand":"_1dMTJ","suffixIcon":"_3uJbv","colorFromFullButton":"_3Fcmg","colorFromHollowButton":"_3HRhK"};